<script>
  // With reference to: https://observablehq.com/@mbostock/scrubber
  // TODO: Make this more svelte-ty
  import { onMount } from "svelte";

  export let value;

  export let values;
  export let format = (value) => value;
  export let initial = 0; // initial selected value
  export let delay = null;
  export let autoplay = true;
  export let loop = true;
  export let loopDelay = null;
  export let alternate = false;
  export let transform;

  // References to DOM elements
  let button;
  let input;
  let output;

  values = Array.from(values);

  let frame = null;
  let timer = null;
  let interval = null;
  let direction = 1;

  function start() {
    button.textContent = "❚❚";

    // Start animation
    if (delay === null) frame = requestAnimationFrame(tick);
    // Start animation with delay between frames
    else interval = setInterval(tick, delay);
  }

  function stop() {
    button.textContent = "▶";

    if (frame !== null) cancelAnimationFrame(frame), (frame = null);
    if (timer !== null) clearTimeout(timer), (timer = null);
    if (interval !== null) clearInterval(interval), (interval = null);
  }

  function running() {
    // Check if animation is stopped or not
    return frame !== null || timer !== null || interval !== null;
  }

  function tick() {
    // If last value of slider
    if (
      input.valueAsNumber ===
      (direction > 0 ? values.length - 1 : direction < 0 ? 0 : NaN)
    ) {
      // Stop the slider
      if (!loop) return stop();
      // Go in the opposite direction
      if (alternate) direction = -direction;
      // Apply loop delay
      if (loopDelay !== null) {
        // Stop animation
        if (frame !== null) cancelAnimationFrame(frame), (frame = null);
        if (interval !== null) clearInterval(interval), (interval = null);
        // Apply the delay
        timer = setTimeout(() => (step(), start()), loopDelay);
        return;
      }
    }
    // Proceed to next frame
    if (delay === null) frame = requestAnimationFrame(tick);
    step();
  }

  function step() {
    // Increment slider value
    input.valueAsNumber =
      (input.valueAsNumber + direction + values.length) % values.length;

    // Dispatch input event
    input.dispatchEvent(new CustomEvent("input", { bubbles: true }));
  }

  onMount(() => {
    // On slider interaction
    input.oninput = (event) => {
      // Stop if animation is running
      if (event && event.isTrusted && running()) stop();

      // Upate DOM values
      value = values[input.valueAsNumber];
      output.value = format(value, input.valueAsNumber, values);
    };

    // On button click
    button.onclick = () => {
      // Stop animation if running
      if (running()) return stop();

      // Else start animation again
      // Change direction if alternating
      direction =
        alternate && input.valueAsNumber === values.length - 1 ? -1 : 1;

      // Increment and dispatch input event
      input.valueAsNumber = (input.valueAsNumber + direction) % values.length;
      input.dispatchEvent(new CustomEvent("input", { bubbles: true }));

      start();
    };

    // Init output value
    input.oninput();

    if (autoplay) start();
    else stop();
  });
</script>

<form style="transform: {transform};">
  <button bind:this={button} type="button" />
  <label>
    <input
      bind:this={input}
      type="range"
      min="0"
      max={values.length - 1}
      value={initial}
      step="1"
    />
    <output bind:this={output} />
  </label>
</form>

<style>
  form {
    font: 12px var(--sans-serif);
    font-variant-numeric: tabular-nums;
    display: flex;
    height: 33px;
    align-items: center;
    position: absolute;
  }

  button {
    margin-right: -30px;
    width: 5em;
    padding: 0;
    background-color: transparent;
    border: none;
    font-size: 20px;
    cursor: pointer;
  }

  button:active {
    background-color: transparent;
  }

  label {
    display: flex;
    align-items: center;
  }

  input {
    width: 180px;
    cursor: pointer;
  }

  output {
    margin-top: -10px;
    margin-left: 0.4em;
    font-weight: 700;
  }
</style>
